/**
 * Thinking Engine — Creative Plan schema (data-driven field/step order).
 *
 * The Creative Plan is complete design REASONING — never layout, coordinates,
 * or objects. `PLAN_DECISION_KEYS` is the ordered set of decision fields (each
 * a { choice, why, basis }); the reasoning pipeline produces exactly these.
 */

export const PLAN_SCHEMA_ID = 'creativeplan/1';
export const PLAN_VERSION = 1;

/** Every decision field of a Creative Plan, in reasoning order. */
export const PLAN_DECISION_KEYS = Object.freeze([
  'businessIntent',
  'marketingIntent',
  'communicationStrategy',
  'creativeDirection',
  'visualLanguage',
  'styleGenome',
  'compositionStrategy',
  'hierarchyStrategy',
  'visualNarrative',
  'typographyStrategy',
  'colorStrategy',
  'photographyStrategy',
  'illustrationStrategy',
  'iconStrategy',
  'shapeStrategy',
  'decorationStrategy',
  'ctaStrategy',
  'contentPriorities',
  'premiumCues',
  'avoidRules',
  'variationAxes',
]);

/** Purposes that make a design offer-led (drives hierarchy + content priorities). */
export const OFFER_LED_PURPOSES = Object.freeze(['sale', 'discount', 'promotion', 'offer', 'grand-opening', 'new-arrival']);

/** The canonical focal order a design ranks, by campaign kind. */
export const HIERARCHY_ROLES = Object.freeze({
  offerLed: Object.freeze(['offer', 'headline', 'cta', 'hero', 'footer']),
  messageLed: Object.freeze(['headline', 'hero', 'cta', 'footer']),
});
